import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { DatePicker } from 'primeng/datepicker';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Select, SelectModule } from 'primeng/select';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { FolioStatusEnum } from '../../../shared/enums/folio-status.enum';
import { SharedModule } from '../../../shared/modules/shared.module';
import { NumberFormatPipe } from '../../../shared/pipe/number-format.pipe';
import { Router } from '@angular/router';
import { CommonService } from '../../../shared/services/common/common.service';
import { FolioService } from '../../../shared/services/folio/folio.service';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { formatEnumLabel } from '../../../shared/utilities/common.utils';
export const FolioStatusLabelMap: Record<FolioStatusEnum, string> = {
  [FolioStatusEnum.DRAFT]: 'Open',
  [FolioStatusEnum.PARTIALLY_PAID]: 'Partially Paid',
  [FolioStatusEnum.PAID]: 'Settled',
  [FolioStatusEnum.VOID]: 'Closed',
};

@Component({
  selector: 'app-folio-table',
  imports: [
    FormsModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    TableModule,
    InputTextModule,
    IconFieldModule,
    SharedModule,
    RouterModule,
    CommonModule,
    InputIcon,
    Select,
    SelectModule,
  ],
  templateUrl: './folio-table.component.html',
  styleUrl: './folio-table.component.scss',
})
export class FolioTableComponent implements OnInit {
  @ViewChild('dt2') private tableRef?: Table;

  formatEnumLabel = formatEnumLabel;
  public data: any[] = [];
  public copyData: any[] = [];
  public page: number = 1;
  public limit: number = 20;
  public totalRecords = 0;
  private user: any;
  private propertyId: any = '';
  public folioStatusEnum = FolioStatusEnum;
  globalSearchValue = '';
  private searchDebounceTimeout: ReturnType<typeof setTimeout> | undefined;

  // public folioStatusOptions = Object.values(this.folioStatusEnum).map(
  //   (status) => ({
  //     label: status,
  //     value: status,
  //   }),
  // );

  getFolioStatusLabel(status: FolioStatusEnum | string): string {
    return FolioStatusLabelMap[status as FolioStatusEnum] || status;
  }

  folioStatusOptions = Object.values(FolioStatusEnum).map((status) => ({
    label: FolioStatusLabelMap[status],
    value: status,
  }));

  public selectedStatus: any | undefined;

  constructor(
    public readonly commonService: CommonService,
    private readonly localStorageService: LocalStorageService,
    private readonly folioService: FolioService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.user = this.localStorageService.getSessionUser();
    this.propertyId = this.user?.propertyStaffs?.[0]?.property?.id;
  }

  /** Loads folios from API (pagination + optional `search` query param). */
  fetchFolioList(): void {
    if (!this.propertyId) return;
    this.folioService
      .getAll(
        this.propertyId,
        this.page,
        this.limit,
        (this.globalSearchValue ?? '').trim() || undefined,
        true,
      )
      .subscribe((res) => {
        const rows = res?.data ?? [];
        this.copyData = [...rows];
        this.totalRecords =
          typeof res?.total === 'number' ? res.total : rows.length;
        this.applyStatusFilter();
      });
  }

  loadFolioPage(event: TableLazyLoadEvent): void {
    const first = event.first ?? 0;
    const rows = event.rows ?? this.limit;
    this.page = Math.floor(first / rows) + 1;
    this.limit = rows;
    this.fetchFolioList();
  }

  onGlobalSearchChange(event: Event): void {
    const value = this.getTarget(event.target).value.trim();
    this.globalSearchValue = value;
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
    }
    this.searchDebounceTimeout = setTimeout(() => {
      this.page = 1;
      if (this.tableRef) {
        this.tableRef.first = 0;
      }
      this.fetchFolioList();
    }, 400);
  }

  private applyStatusFilter(): void {
    if (!this.selectedStatus) {
      this.data = [...this.copyData];
      return;
    }
    this.data = this.copyData.filter(
      (folio) => folio.status === this.selectedStatus,
    );
  }
  getTarget(target: EventTarget | null): HTMLInputElement {
    return target as HTMLInputElement;
  }

  getEngagementColor(value: number): string {
    if (value <= 40) {
      return '#1AAA55'; // green
    } else if (value <= 80) {
      return '#FC9403'; // yellow
    } else {
      return '#DB3B21'; // red
    }
  }

  clear(table: Table) {
    this.selectedStatus = null;
    this.globalSearchValue = '';
    this.page = 1;
    table.first = 0;
    table.clear();
    this.fetchFolioList();
  }

  onChangeFilter(event?: any) {
    this.applyStatusFilter();
  }
  goToDetails(id: string) {
    this.router.navigate(['pms/folio-details', id]);
  }
}
